import React from "react";
import PropTypes from "prop-types";
import { Stack, Chip } from "@mui/material";

const FilterChips = ({ options, activeKey, counts, onChange }) => {
  return (
    <Stack direction="row" spacing={1} sx={{ overflowX: "auto", pb: 1 }}>
      {options.map((chip) => {
        const isSelected = chip.key === activeKey;

        return (
          <Chip
            key={chip.key}
            label={`${chip.label} (${counts?.[chip.countKey] ?? 0})`}
            onClick={() => onChange(chip.key)}
            clickable
            disableRipple
            variant="outlined"
            sx={{
              backgroundColor: isSelected ? "#F1F6FE" : "#fff",
              border: isSelected ? "1px solid #DAE6F7" : "1px solid #E0E0E0",
              color: isSelected ? "#0C53BB" : "#333",
              "& .MuiChip-label": {
                fontWeight: isSelected ? 600 : 400,
              },
              "&:hover": {
                backgroundColor: "#EDF3FC",
              },
            }}
          />
        );
      })}
    </Stack>
  );
};

FilterChips.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      countKey: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeKey: PropTypes.string.isRequired,
  counts: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FilterChips;
